"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Mail } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-4">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-24 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-x-6 gap-y-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-[var(--duration-medium)] relative after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-foreground-dark after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/strucon.group"
  }, {
    icon: Instagram,
    label: "Instagram",
    href: "https://www.instagram.com/strucon_group/"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/79476277/admin/dashboard/"
  }];
  return <footer className="bg-dark-background text-foreground-dark py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pb-8 border-b border-foreground-dark/20">
          <div className="flex items-center gap-6">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} data-index={i} aria-label={social.label} className="text-foreground-dark/70 hover:text-foreground-dark hover:scale-105 transition-all duration-[var(--duration-medium)] hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          <MenuProvider menu_id="12" className="footer-nav">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-foreground-dark/70">
          <p>&copy; {new Date().getFullYear()} Strucon Group. All rights reserved.</p>
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p className="flex items-center gap-1.5">
              Call us:{" "}
              <Link to="tel:0432061310" className="text-foreground-dark hover:text-primary-light transition-colors duration-[var(--duration-medium)]">
                0432 061 310
              </Link>
            </p>
            <span className="hidden md:inline text-foreground-dark/40">|</span>
            <p className="flex items-center gap-1.5">
              <Mail className="size-4" />
              <Link to="mailto:strucon.group@hotmail.com" className="text-foreground-dark hover:text-primary-light transition-colors duration-[var(--duration-medium)]">
                strucon.group@hotmail.com
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}